{% block uc_milestones_page %}
<sw-page class="uc-milestones-page">

    {% block uc_milestones_smart_bar_header %}
    <template #smart-bar-header>
        <sw-button
            class="uc-milestones-page__back-btn"
            variant="ghost"
            size="small"
            @click="goToConfig"
        >
            <sw-icon name="regular-chevron-left-s" size="16px" class="uc-milestones-page__back-icon" />
            {{ $tc('sellops-ultimate-cart.general.back') }}
        </sw-button>
        <h2>{{ $tc('sellops-ultimate-cart.milestones.pageTitle') }}</h2>
    </template>
    {% endblock %}

    {% block uc_milestones_content %}
    <template #content>
        <sw-card-view>

            <sw-card :title="$tc('sellops-ultimate-cart.milestones.cardTitle')">
                <p class="uc-milestones-page__subline">
                    {{ $tc('sellops-ultimate-cart.milestones.cardSubline') }}
                </p>
                <uc-milestone-manager />
            </sw-card>

        </sw-card-view>
    </template>
    {% endblock %}

</sw-page>
{% endblock %}
